<div class='text-input__loading' *ngIf="loading">
    <div class='text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>

    <div class='mt-20 text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>

    <div class="loader" *ngIf="loader"></div>

    <div class='mt-20 text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>

    <div class='mt-20 text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>
    <div class='text-input__loading--line'></div>

    <div class='mt-20 text-input__loading--line'></div>
</div>
